import { MdOutlineWarning } from 'react-icons/md';
import { useDonorEta } from '@lp/features/RoutePlanner/hooks/useDonorEta';
import { useRouteDetails } from '@lp/features/RoutePlanner/hooks/useRouteDetails';
import { RouteTypeEnum } from '@/api/apis/route';
import { convertToTimezoneOffset } from '@/utils/helpers';

export const LogisticsInfoWarnings = () => {
  const { legs: mainLegs } = useRouteDetails(RouteTypeEnum.Main);
  const { offsetInMs } = useDonorEta(mainLegs);

  if (!offsetInMs) return null;

  return (
    <div className="flex gap-2 items-center max-w-full">
      <div className="text-warning-30">
        <MdOutlineWarning size={16} />
      </div>
      <span className="text-s-r text-base-10">{`The ETA to Donor Hospital is ${convertToTimezoneOffset(offsetInMs, false)}h after current OR time.`}</span>
    </div>
  );
};
